import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=12b49a00&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=12b49a00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b49a00",
  null
  
)

export default component.exports